import { FC, useMemo } from 'react'
import { ButtonTransformer } from 'src/relay/Transformers/ButtonTransormer'
import MiniPushes, { MiniPushesProps } from 'src/components/MiniPushes'
import { getThemeColor } from 'src/relay/Transformers/ThemeTransformer'

import { BlockProps } from '../props'

import { PushGridBlockProps } from './props'

const PushGridBlock: FC<BlockProps<PushGridBlockProps>> = ({ data }) => {
  const props: MiniPushesProps = useMemo(
    () => ({
      ...(data.title && {
        blockTitleProps: {
          title: data.title,
          actionButtonProps: ButtonTransformer({ data: data.cta }),
        },
      }),
      links: data.pushContentGrid?.map((link) => ({
        text: link.title,
        href: link.url,
        color: getThemeColor(data.theme?.data),
      })),
    }),
    [data]
  )

  return <MiniPushes {...props} />
}

export default PushGridBlock
